import { Box, Stack, Typography } from '@montugroup/design-system';
import { styled } from '@mui/material';

export const StyledUmedsLogoFooterSubText = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  fontSize: '1.5rem',
  color: theme.palette.secondary.main,
  marginTop: theme.spacing(4),
  display: 'flex',
  justifyContent: 'center',
  letterSpacing: '0.15rem',
}));

export const StyledPaymentOptionsFooter = styled('li')(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  borderRadius: theme.spacing(1.5),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: theme.spacing(8),
  width: theme.spacing(10.5),
  listStyle: 'none',
  '& img': {
    maxHeight: '100%',
    maxWidth: '100%',
    objectFit: 'contain',
  },
}));

export const StyledGridItemFooter = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  height: '100%',
}));

export const SocialIcons = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(6),
  '& svg': {
    color: theme.palette.secondary.main,
    cursor: 'pointer',
    '&:hover': {
      opacity: 0.8,
    },
  },
}));

export const StyledButtonStack = styled(Stack)(({ theme }) => ({
  width: '100%',
  maxWidth: theme.spacing(64),
  [theme.breakpoints.up('md')]: {
    width: 'auto',
    maxWidth: 'unset',
  },
}));

export const StyledNav = styled(Box)(() => ({
  flexDirection: 'row',
  display: 'flex',
  width: '100%',
  justifyContent: 'space-between',
  alignItems: 'center',
}));
